import { InputText } from "primereact/inputtext";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const Preview = ({ changeableData }) => {
    const isHit = changeableData?.offerOptions?.includes("hit");

    const vendorImgs = { cover: changeableData?.vendor?.logoList };
    const image = changeableData?.cover || vendorImgs?.cover || "";

    return (
        <div className={`offer ${isHit ? "hit" : ""}`}>
            <div className="offers">
                <div>
                    <div className={`content__img`}>
                        {image ? <img src={image} /> : null}
                        <div className="share">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.22825 5.2405V1.59961L15.598 7.97117L9.22825 14.3427V10.7018C4.67846 10.7018 2.55995 12.3996 0.399994 14.3996C1.83203 9.59961 3.27091 7.82045 4.63203 6.79961C5.99314 5.77877 7.22067 5.44016 9.22825 5.2405Z"
                                    fill="#1e22aa"
                                />
                            </svg>
                        </div>
                    </div>
                    <span className="content__date">Обновлен 11.11.2024</span>

                    <div
                        className="content__title"
                        dangerouslySetInnerHTML={{
                            __html: changeableData.title,
                        }}
                    ></div>
                    <div className={`content__desc `}>
                        Сегодня это предложение забрали <span>5942 человек</span>
                    </div>
                </div>

                <div className="form">
                    <InputText placeholder="Укажите Email" className="input_email" />

                    <div className="form__captcha">
                        <div className="form__button">
                            <ButtonUI label={"Получить предложение"} id="button_send" className="form__button_get-offer" />
                        </div>
                    </div>
                    <span className="form__desc">
                        Нажимая кнопку «Получить предложение», я соглашаюсь с{" "}
                        <a href="https://ris.promo/pdf/privacy.pdf" target="_blank" rel="noreferrer">
                            политикой конфиденциальности
                        </a>
                        , а также даю согласие{" "}
                        <a href=" https://ris.promo/pdf/processing_of_personal_data.pdf" target="_blank">
                            ООО &quot;РИС&quot;
                        </a>{" "}
                        на направление мне рекламных сообщений и на обработку персональных данных.
                    </span>
                </div>
                <div className="form__ord">{changeableData?.offerDetail?.ordRisPromo}</div>
                <div className="offers__description" dangerouslySetInnerHTML={{ __html: changeableData?.description }}></div>

                <div className="offers__details_btn cursor">Скрыть</div>

                <div className={`offers__terms open`} dangerouslySetInnerHTML={{ __html: changeableData?.offerDetail?.termsOfUse }}></div>
            </div>
        </div>
    );
};

export default Preview;
